<template>
    <b-modal size="lg"
     v-model="mostrarModal"
      no-close-on-backdrop
      @close="fecharModal()">
        <div slot="modal-title">
            Prestação de Contas Mensal -
            <b-badge variant="warning">{{
                operacao == 'I' ? 'INCLUSÃO' : 'ATUALIZAÇÃO'
            }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="dtCompetencia">Competência</label>
                    <b-input-group>
                        <date-picker
                            id="dtCompetencia"
                            v-model="prestacoesContasMensal.dtCompetencia"
                            :config="$monthPickerOptions"
                            v-mask="'##/####'"
                            @input.native="$v.mesPrevisto.$touch()"
                        ></date-picker>
                        <b-form-invalid-feedback
                            >Competência é obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="dtPrestacao">Data Prestação</label>
                    <b-input-group>
                        <date-picker
                            id="dtPrestacao"
                            v-model="prestacoesContasMensal.dtPrestacao"
                            @input.native="
                                $v.convenio.dtInicioVigencia.$touch()
                            "
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                        ></date-picker>
                        <b-form-invalid-feedback
                            >Data Prestação é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="nuTotalGasto">Total Despesas</label>
                    <b-input-group>
                        <money
                            id="nuTotalGasto"
                            v-model="prestacoesContasMensal.nuTotalGasto"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="
                                $v.prestacoesContasMensal.nuTotalGasto.$touch()
                            "
                        ></money>
                        <b-form-invalid-feedback
                            >Total Despesas é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="nuTotalRendimentos">Total Rendimentos</label>
                    <b-input-group>
                        <money
                            id="nuTotalRendimentos"
                            v-model="prestacoesContasMensal.nuTotalRendimentos"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="
                                $v.prestacoesContasMensal.nuTotalRendimentos.$touch()
                            "
                        ></money>
                        <b-form-invalid-feedback
                            >Total Rendimentos é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="nuReceitasDiversas">Receitas Diversas</label>
                    <b-input-group>
                        <money
                            id="nuReceitasDiversas"
                            v-model="prestacoesContasMensal.nuReceitasDiversas"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="
                                $v.prestacoesContasMensal.nuReceitasDiversas.$touch()
                            "
                        ></money>
                        <b-form-invalid-feedback
                            >Receitas Diversas é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        operacao: {
            type: String,
            default: () => 'X'
        },

        prestacoesContasMensalAtual: {
            type: Object
        },

        erros: {
            type: Array
        }
    },

    validations: {
        prestacoesContasMensal: {
            dtCompetencia: { required },
            dtPrestacao: { required },
            nuTotalGasto: { required },
            nuTotalRendimentos: { required },
            nuReceitasDiversas: { required }
        }
    },

    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            prestacoesContasMensal: {
                idConvenio: 0,
                idPrestacaoContasMensal: 0,
                dtCompetencia: null,
                dtPrestacao: null,
                nuReceitasDiversas: 0,
                nuTotalGasto: 0,
                nuTotalRendimentos: 0,
                nuValorPendente: null,
                valorConferido: 0
            }
        }
    },

    methods: {
        preencher() {
            this.prestacoesContasMensal.idConvenio = this.prestacoesContasMensalAtual.idConvenio
            this.prestacoesContasMensal.idPrestacaoContasMensal = this.prestacoesContasMensalAtual.idPrestacaoContasMensal
            this.prestacoesContasMensal.dtCompetencia = this.$moment(this.prestacoesContasMensalAtual.dtCompetencia).format('MM/YYYY')
            this.prestacoesContasMensal.dtPrestacao = this.$moment(this.prestacoesContasMensalAtual.dtPrestacao).format('DD/MM/YYYY')
            this.prestacoesContasMensal.nuReceitasDiversas =
                this.prestacoesContasMensalAtual.nuReceitasDiversas
            this.prestacoesContasMensal.nuTotalGasto =
                this.prestacoesContasMensalAtual.nuTotalGasto
            this.prestacoesContasMensal.nuTotalRendimentos =
                this.prestacoesContasMensalAtual.nuTotalRendimentos
            this.prestacoesContasMensal.nuValorPendente =
                this.prestacoesContasMensalAtual.nuValorPendente
            this.prestacoesContasMensal.valorConferido =
                this.prestacoesContasMensalAtual.valorConferido
        },

        reset() {
            this.prestacoesContasMensal.idConvenio = 0
            this.prestacoesContasMensal.idPrestacaoContasMensal = 0
            this.prestacoesContasMensal.dtCompetencia = null
            this.prestacoesContasMensal.dtPrestacao = null
            this.prestacoesContasMensal.nuReceitasDiversas = 0
            this.prestacoesContasMensal.nuTotalGasto = 0
            this.prestacoesContasMensal.nuTotalRendimentos = 0
            this.prestacoesContasMensal.nuValorPendente = 0
            this.prestacoesContasMensal.valorConferido = 0
        },

        fecharModal() {
            this.$emit('fecharModal')
        },

        salvar() {
            this.$emit('salvar', this.prestacoesContasMensal)
        }
    },

    watch: {
        mostrarModal() {
            if (this.mostrarModal && this.operacao == 'A') {
                this.preencher()
            } else {
                this.reset()
            }
        }
    }
}
</script>